import { render, staticRenderFns } from "./ServiceBoard.vue?vue&type=template&id=7277a8ac&"
import script from "./ServiceBoard.vue?vue&type=script&lang=js&"
export * from "./ServiceBoard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBoard.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFlex,VIcon})
